import jhsfBookingsApi from '../apis/jhsfBookingsApi';

const deleteActivityAvatarsService = async (
  activityId: string,
): Promise<void> => {
  await jhsfBookingsApi.delete(`/avatars/activities/${activityId}`);
};

export default deleteActivityAvatarsService;
